/* eslint-disable max-len */
import React from 'react';
import { SebMount } from './SebCommon';
import init from './SebMeetingInit';
import { useSvgPlayer, useToggledMirrorAnim } from './SvgPlayerUtil';

export const SebMeeting = ({ size, active }: { size?: number, active?: boolean }) => {

    const [player, setPlayerElmt] = useSvgPlayer(init);
    useToggledMirrorAnim(player, !!active);

    return <SebMount size={size}>
        <svg id="eL3jfdhqBUb1" ref={setPlayerElmt} viewBox="0 0 55 75" shapeRendering="geometricPrecision" textRendering="geometricPrecision">
            <g transform="translate(2.037746 24.914449)">
                <g mask="url(#eL3jfdhqBUb9)">
                    <g>
                        <path
                            d="M7.08726,3.19409c0,0,10.42004,2.63,28.65004,0c0,0-2.6,18.38001,5.21,31.51001c0,0-5.21,7.88-31.25004,7.88.05,0-10.420004-21.01-2.61-39.39001v0Z"
                            fill="#fff" />
                        <g opacity="0.2">
                            <path
                                d="M7.08726,3.19409c0,0,10.42004,2.63,28.65004,0c0,0-2.6,18.38001,5.21,31.51001c0,0-5.21,7.88-31.25004,7.88.05,0-10.420004-21.01-2.61-39.39001v0Z"
                                transform="translate(-.24-.32)" fill="#3b65ef" />
                        </g>
                        <path
                            d="M9.74723,43.7942c-.2236.0009-.44325-.0591-.6353-.1736s-.34926-.2793-.4547-.4765c-.43-.88-10.57-21.7199-2.63-40.39995.11278-.26623.31644-.48376.57468-.6138s.55428-.16413.83532-.0962c.1,0,10.43997,2.53,28.17997,0c.3139-.04619.6333.03274.8896.21977s.4288.46723.4804.78023c.0194.1125.0194.2275,0,.34c0,.18-2.45,18.12005,5,30.72005.1229.1927.1881.4164.1881.645s-.0652.4522-.1881.645c-.24.33-5.9,8.41-32.23997,8.41Zm-1.92-39.20005c-6.08,15.63005,1,33.15005,2.63997,36.77005c20.23-.12,27.24-5.17,29-6.82-6.2-11.12-5.54-25.23005-5.1-29.94005-14.34,1.89-23.56.54-26.53997-.01v0Z"
                            fill="#3b65ef" />
                    </g>
                    <mask id="eL3jfdhqBUb9" mask-type="alpha" x="-150%" y="-150%" height="400%" width="400%">
                        <rect width="50" height="39" rx="0" ry="0" transform="matrix(1 0 0-1 1 39)" fill="#d9d9d9" />
                    </mask>
                </g>
                <g id="eL3jfdhqBUb11" transform="translate(.000001 0)">
                    <path
                        d="M18.5072,22.26c1.436,0,2.6-1.1775,2.6-2.63s-1.164-2.63-2.6-2.63-2.6,1.1775-2.6,2.63s1.1641,2.63,2.6,2.63Z"
                        fill="#3b65ef" />
                    <path
                        d="M26.7072,22.26c1.4359,0,2.6-1.1775,2.6-2.63s-1.1641-2.63-2.6-2.63-2.6,1.1775-2.6,2.63s1.164,2.63,2.6,2.63Z"
                        fill="#3b65ef" />
                </g>
                <path d="M1.5,39h43.5" fill="none" stroke="#3b65ef" strokeWidth="2" strokeLinecap="round"
                    strokeLinejoin="round" />
                <path d="M25.8947,48.3846l.7895-5.5384h-8.6842l7.8947,5.5384Z" fill="#fff" />
                <path d="M48,33h-19.8947l-1.4211,9.8462-.7895,5.5384h19.8948L48,33Z" fill="#fff" />
                <path
                    d="M25.8947,48.3846h19.8948L48,33h-19.8947l-1.4211,9.8462m-.7895,5.5384l.7895-5.5384m-.7895,5.5384L18,42.8462h8.6842"
                    fill="none" stroke="#fff" strokeWidth="2" strokeLinejoin="round" />
                <path d="M25.8947,48.3846l.7895-5.5384h-8.6842l7.8947,5.5384Z" fill="#3b65ef" fillOpacity="0.2"
                    strokeLinecap="round" />
                <path d="M48,33h-19.8947l-1.4211,9.8462-.7895,5.5384h19.8948L48,33Z" fill="#3b65ef" fillOpacity="0.2"
                    strokeLinecap="round" />
                <path d="M18,29c4,.5,7,.5,10.5-1" fill="none" stroke="#3b65ef" strokeWidth="2" strokeLinecap="round"
                    strokeMiterlimit="10" />
                <path id="eL3jfdhqBUb21"
                    d="M19.235211,54.300356c-.124216-.691722.12-1.24.74-1.34c2.967905.946781,7.96421.279805,10.42-.96.5-.02.7.08.98.5.56,1.18-1.48,2.12-5.9,2.6-4.901728.067147-6-.26-6.24-.8Z"
                    transform="translate(-2.06373-24.924622)" fill="#3b65ef" strokeWidth="0.5" strokeLinecap="round"
                    strokeLinejoin="round" />
                <path
                    d="M25.8947,48.3846h19.8948L48,33h-19.8947l-1.4211,9.8462m-.7895,5.5384l.7895-5.5384m-.7895,5.5384L18,42.8462h8.6842"
                    fill="none" stroke="#3b65ef" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </svg>
    </SebMount>;
};
